import React, { FC } from 'react';
import { HiGlobeAlt, HiDeviceMobile, HiWifi } from 'react-icons/hi';
import { DeviceType, IDevice } from '../../../../types';

interface DeviceInformationCardProps {
  deviceDetail: IDevice | undefined;
}

const getDeviceTypeLabel = (deviceType?: DeviceType): string => {
  switch (deviceType) {
    case DeviceType.INVITE:
      return 'Invite';
    case DeviceType.BOT:
      return 'Bot';
    case DeviceType.AGENT_WP:
      return 'WhatsApp Temsilci';
    case DeviceType.AGENT_TG:
      return 'Telegram Temsilci';
    default:
      return 'Bilinmiyor';
  }
};

export const DeviceInformationCard: FC<DeviceInformationCardProps> = ({
  deviceDetail,
}) => {
  return (
    <div className="space-y-4">
      {/* Device Information Grid */}
      <div className="grid grid-cols-1 gap-3">
        {/* Client Status */}
        <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200 hover:shadow-sm transition-shadow">
          <div className="flex-shrink-0">
            <HiWifi className="h-5 w-5 text-green-500" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
              Bağlantı Durumu
            </div>
            <div className="text-sm text-gray-900 truncate">
              {deviceDetail?.clientStatus || 'Bilinmiyor'}
            </div>
          </div>
        </div>

        {/* IP Address */}
        <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200 hover:shadow-sm transition-shadow">
          <div className="flex-shrink-0">
            <HiGlobeAlt className="h-5 w-5 text-green-500" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
              IP Adresi
            </div>
            <div className="text-sm text-gray-900 truncate">
              {deviceDetail?.ip || 'Bilinmiyor'}
            </div>
          </div>
        </div>

        {/* Device Type */}
        <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200 hover:shadow-sm transition-shadow">
          <div className="flex-shrink-0">
            <HiDeviceMobile className="h-5 w-5 text-orange-500" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
              Cihaz Tipi
            </div>
            <div className="text-sm text-gray-900 truncate">
              {getDeviceTypeLabel(deviceDetail?.deviceType)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
